import { render, staticRenderFns } from "./GiudizioConclusivoEditComponent.vue?vue&type=template&id=50f95ccc"
import script from "./GiudizioConclusivoEditComponent.vue?vue&type=script&lang=js"
export * from "./GiudizioConclusivoEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports